import React from 'react';
import * as FlexWebChat from "@twilio/flex-webchat-ui";

class App extends React.Component {
  

  state = {};

  constructor(props) {
    super(props);

    const { configuration } = props;
    FlexWebChat.Manager.create(configuration)
      .then(manager => this.setState({ manager }))
      .catch(error => this.setState({ error }));

      
  }


  
  render() {
    
    //FlexWebChat.MessagingCanvas.defaultProps.predefinedMessage = false;
    FlexWebChat.MessagingCanvas.defaultProps.showWelcomeMessage = false;
   // FlexWebChat.MessagingCanvas.defaultProps.welcomeMessageText="New text for welcome message"
      FlexWebChat.EntryPoint.defaultProps.tagline="Chateanos";
      FlexWebChat.MainHeader.defaultProps.imageUrl='https://www.silaba.com/images/logo-n.png';
      FlexWebChat.MainHeader.defaultProps.titleText="Silaba Chat";
      FlexWebChat.MessagingCanvas.defaultProps.predefinedMessage=false;
     // FlexWebChat.MessagingCanvas.defaultProps.predefinedMessage.body="Hola welcome";
     // FlexWebChat.MessagingCanvas.defaultProps.predefinedMessage.authorName="Grupo Silaba";
      FlexWebChat.MessagingCanvas.defaultProps.memberDisplayOptions={
        yourDefaultName: 'You',      
        theirDefaultName: 'Grupo Silaba',      
        yourFriendlyNameOverride: true,      
        theirFriendlyNameOverride: false      
      }
     
    const { manager, error } = this.state;
    
    if (manager) {
      return (
        <FlexWebChat.ContextProvider manager={manager}>
          <FlexWebChat.RootContainer />
        </FlexWebChat.ContextProvider>
      );
    }

    if (error) {
      console.error("Failed to initialize Flex Web Chat", error);
    }

    return null;
  }
}

export default App;
